import type { FaireThemeEntity } from "../../entity_types/theme";

export const mama_baby_comfort: FaireThemeEntity = {
  token: "mama-baby-comfort",
  type: "theme",
  name: "Welcome Baby",
  description: "This theme drives revenue because you've already purchased baby gowns (knotted/newborn styles) and belly oil/maternity-adjacent items--so you can create a cohesive 'new baby + postpartum comfort' tabl",
  teaser: "Turn your baby basics into a full new-arrival gifting destination.",
  detail: "You've already purchased newborn gowns and maternity-adjacent items, so the customer trust is there. Rounding out with postpartum comfort and feeding essentials lets you own the new-parent moment from bump to baby.",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_7wri7evhpd",
    "p_2uz5b9at8y",
    "p_g2jrz3ksar",
    "p_bxwynnja65",
    "p_5c23wth5k4",
    "p_1uup1tpwx5",
    "p_ksha8cajze",
    "p_495tk8rjga",
    "p_xm7cax6edw",
    "p_pu9f7w7pak",
    "p_9dzxk3jqdk",
    "p_ext9cfnlbs",
    "p_mccfv8byqk",
    "p_xsc47wxygf",
    "p_x3qnc3xrmz",
    "p_dh9rr5qtug",
    "p_enrcc24jph",
    "p_ku98jqh964",
    "p_nnymznqp6p",
    "p_xpntb3ceem",
    "p_a7727vbm2c",
    "p_yeeg7p39g3",
    "p_5jge3pcjq9",
    "p_e46pwwz8q9",
    "p_b9dm8btcqc",
    "p_4ftttka3bu",
    "p_knzvrvtdkc",
    "p_6qeb3h4mtm",
    "p_2787j24nz7",
    "p_xg57j3vxbc",
    "p_n89nwx6fqz",
    "p_22vh87r2jw",
    "p_kp845dmm3w",
    "p_t7uw6aq3c6",
    "p_4te66x7yz8",
    "p_xdu7he3kff",
    "p_e7ffsnbnn9",
    "p_wy8qw7zsss",
    "p_6vrmumuh56",
    "p_5da7gzv6mv",
    "p_jzdycrxdbt",
    "p_hwyrcvffxm",
    "p_7cxnaz9c3m",
    "p_7wss2n6nbx",
    "p_56umj2kasr",
    "p_j693pnppdd",
    "p_krp3k6v7zc",
    "p_2emndz4avz",
    "p_x52a7n32nm",
    "p_2tw29tn6ka",
    "p_pgcb644jqz",
    "p_8q7vpbbst2",
    "p_677wpq5eyh",
    "p_7gxspth2pe",
    "p_pnmgacsnph",
    "p_55gbay0rfy",
    "p_vstts73ex5",
    "p_vvmpgpu2h9",
    "p_4sj1piqs",
    "p_n2f4p5pugb",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
